import { useTranslation } from "react-i18next";

const SuperAdmin = () => {
  const { t } = useTranslation();
  const superAdminNavArray = [
    // ------- Dashboard -------
    {
      id: "dashboard",
      title: t("navigation.superAdmin.dashboard") || "Dashboard",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="2" y="2" width="9" height="9" rx="2" fill="#4F46E5" />
          <rect x="13" y="2" width="9" height="9" rx="2" fill="#06B6D4" />
          <rect x="2" y="13" width="9" height="9" rx="2" fill="#10B981" />
          <rect x="13" y="13" width="9" height="9" rx="2" fill="#F59E0B" />
          <circle cx="6.5" cy="6.5" r="2" fill="white" />
          <circle cx="17.5" cy="6.5" r="2" fill="white" />
          <circle cx="6.5" cy="17.5" r="2" fill="white" />
          <circle cx="17.5" cy="17.5" r="2" fill="white" />
        </svg>
      ),
      navLink: "/super-admin/dashboard",
    },
    // ------- Admins -------
    {
      id: "admins",
      title: t("navigation.superAdmin.admins") || "Admins",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="8" r="4" fill="#E0F2FE" stroke="#0EA5E9" strokeWidth="2"/>
          <circle cx="12" cy="8" r="2.5" fill="#3B82F6"/>
          <circle cx="12" cy="8" r="1" fill="white"/>
          <path
            d="M4 20V18C4 15.7909 5.79086 14 8 14H16C18.2091 14 20 15.7909 20 18V20"
            fill="#DBEAFE"
            stroke="#3B82F6"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <rect x="14" y="12" width="8" height="5" rx="2" fill="#DC2626"/>
          <path d="M16 14.5L17 15.5L20 12.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="10" cy="6" r="1.5" fill="#F59E0B"/>
          <path d="M9.5 6L10 6.5L10.5 5.5" stroke="white" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      navLink: "/super-admin/admins",
    },
    // ------- Visitors -------
    {
      id: "visitors",
      title: t("navigation.superAdmin.visitors") || "Visitors",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none">
            <path fill="#1C1C1C" d="M16 2c3.31 0 6 2.693 6 6.006v15.988A6.008 6.008 0 0 1 16 30c-3.31 0-6-2.693-6-6.006V8.006A6.008 6.008 0 0 1 16 2Z"/>
            <path fill="#00D26A" d="M16 27a3 3 0 1 0 0-6a3 3 0 0 0 0 6Z"/>
            <path fill="#00F397" d="M17 24a1 1 0 1 0 0-2a1 1 0 0 0 0 2Z"/>
            <path fill="#F8312F" d="M16 11a3 3 0 1 0 0-6a3 3 0 0 0 0 6Z"/>
            <path fill="#FFB02E" d="M16 19a3 3 0 1 0 0-6a3 3 0 0 0 0 6Z"/>
            <path fill="#FF8687" d="M17 8a1 1 0 1 0 0-2a1 1 0 0 0 0 2Z"/>
            <path fill="#FCD53F" d="M17 16a1 1 0 1 0 0-2a1 1 0 0 0 0 2Z"/>
            <path fill="#636363" d="M12.8 7c-.341 0-.591-.324-.451-.636a4 4 0 0 1 7.302 0c.14.312-.11.636-.452.636a.588.588 0 0 1-.514-.34a3 3 0 0 0-5.37 0a.588.588 0 0 1-.514.34Zm-.451 7.364c-.14.312.11.636.452.636a.588.588 0 0 0 .514-.34a3 3 0 0 1 5.37 0c.099.198.293.34.514.34c.342 0 .592-.324.452-.636a4.001 4.001 0 0 0-7.302 0Zm-.001 8c-.14.312.11.636.452.636a.588.588 0 0 0 .514-.34a3 3 0 0 1 5.37 0c.099.198.293.34.514.34c.342 0 .592-.324.452-.636a4 4 0 0 0-7.302 0Z"/>
          </g>
        </svg>
      ),
      navLink: "/super-admin/visitors",
    },
    // ------- Analytics -------
    {
      id: "analytics",
      title: t("navigation.superAdmin.analytics") || "Analytics",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="3" y="3" width="18" height="18" rx="3" fill="#F3E8FF" stroke="#8B5CF6" strokeWidth="2"/>
          <rect x="6" y="14" width="3" height="5" rx="1" fill="#8B5CF6"/>
          <rect x="10.5" y="10" width="3" height="9" rx="1" fill="#A855F7"/>
          <rect x="15" y="6" width="3" height="13" rx="1" fill="#7C3AED"/>
          <circle cx="7.5" cy="8" r="1.5" fill="#F59E0B"/>
          <circle cx="12" cy="5" r="1.5" fill="#10B981"/>
          <circle cx="16.5" cy="3" r="1.5" fill="#3B82F6"/>
          <path d="M7.5 8L12 5L16.5 3" stroke="#94A3B8" strokeWidth="1" strokeLinecap="round" strokeDasharray="2 2"/>
        </svg>
      ),
      navLink: "/super-admin/analytics",
    },
    // ------- Constants -------
    {
      id: "constants",
      title: t("navigation.superAdmin.constants") || "Constants",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="3" y="3" width="18" height="18" rx="3" fill="#E0F2FE" stroke="#0EA5E9" strokeWidth="2"/>
          <path d="M9 7V17M15 7V17M7 12H17" stroke="#3B82F6" strokeWidth="2" strokeLinecap="round"/>
          <circle cx="9" cy="9" r="1.5" fill="#F59E0B"/>
          <circle cx="15" cy="15" r="1.5" fill="#10B981"/>
          <circle cx="12" cy="12" r="1" fill="#EF4444"/>
        </svg>
      ),
      navLink: "/super-admin/constants",
    },
    // ------- Copilots -------
    {
      id: "copilots",
      title: t("navigation.superAdmin.copilots") || "Copilots",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21 16V8C21 6.89543 20.1046 6 19 6H5C3.89543 6 3 6.89543 3 8V16C3 17.1046 3.89543 18 5 18H19C20.1046 18 21 17.1046 21 16Z"
            fill="#E0F2FE"
            stroke="#0EA5E9"
            strokeWidth="2"
          />
          <circle cx="8" cy="11" r="2" fill="#3B82F6"/>
          <circle cx="16" cy="11" r="2" fill="#3B82F6"/>
          <path d="M8 15H16" stroke="#10B981" strokeWidth="2" strokeLinecap="round"/>
          <path d="M12 2V6" stroke="#F59E0B" strokeWidth="2" strokeLinecap="round"/>
          <circle cx="12" cy="2" r="1" fill="#F59E0B"/>
          <rect x="5" y="18" width="4" height="2" rx="1" fill="#8B5CF6"/>
          <rect x="15" y="18" width="4" height="2" rx="1" fill="#8B5CF6"/>
        </svg>
      ),
      navLink: "/super-admin/copilots",
    },
    // ------- Blogs -------
    {
      id: "blogs",
      title: t("navigation.superAdmin.blogs") || "Blogs",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 256 256"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path fill="#F06A35" d="M29.251 254.992c-4.79-1.262-8.924-3.12-12.737-5.722c-3.218-2.197-7.922-6.739-9.711-9.376c-2.185-3.222-4.696-8.738-5.72-12.564c-1.044-3.903-1.06-5.457-1.08-99.134c-.018-93.203.003-95.253 1.026-99.258C4.648 14.773 15.853 3.996 30.305.78C34.46-.144 220.08-.305 224.562.61c12.135 2.483 21.673 9.78 27.192 20.805c4.388 8.765 3.996-.88 4.197 103.185c.128 66.212.01 94.01-.412 97.473c-1.976 16.205-13.134 28.775-29.19 32.882c-4.108 1.05-5.537 1.066-98.789 1.037c-90.164-.027-94.794-.074-98.309-1Z"/>
          <path fill="#FFF" d="M164.338 206.474c11.47-1.564 20.458-6.162 28.89-14.776c6.1-6.232 9.918-12.977 12.414-21.93c1.036-3.719 1.123-5.53 1.313-27.365c.144-16.481.024-24.2-.405-26.148c-.622-2.825-2.385-5.448-4.397-6.541c-.62-.337-4.586-.766-8.815-.953c-7.087-.315-7.88-.453-10.116-1.764c-3.548-2.08-4.525-4.324-4.535-10.42c-.019-11.647-4.866-22.46-14.442-32.22c-6.823-6.952-14.434-11.658-23.12-14.295c-2.08-.632-6.737-.847-22.333-1.03c-24.472-.29-29.904.212-38.236 3.53c-15.36 6.118-26.395 19.011-30.421 35.541c-.756 3.105-.903 8.08-1.082 36.663c-.223 35.808.023 41.066 2.26 48.162c1.85 5.863 3.715 9.456 7.557 14.555c7.32 9.715 18.29 16.73 29.258 18.712c5.22.943 69.615 1.179 76.21.28Z"/>
          <path fill="#F06A35" d="M162.317 150.441c4.233 3.953 3.34 10.99-1.761 13.88l-5.243.853l-30.939.358c-20.86.195-27.128-.216-28.409-.724l-.04-.017c-2.518-1.097-4.862-4.143-5.267-6.845c-.386-2.573.908-6.11 2.89-7.905l.441-.384c1.954-1.605 4.202-1.893 22.635-1.958l21.317-.022c21.549.016 21.738.301 24.376 2.764ZM131.944 92.09c3.286 1.66 4.714 4 4.714 7.727c0 3.236-1.24 5.54-3.994 7.398l-.534.341c-1.34.8-2.654.939-13.041 1.02l-6.703.038c-8.309.017-14.705-.157-15.727-.439c-5.864-1.616-8.055-10.029-3.745-14.38l.401-.398c2.307-2.235 3.775-2.466 17.292-2.487l10.186.008c8.608.04 9.295.235 11.151 1.172Z"/>
        </svg>
      ),
      navLink: "/super-admin/blogs",
    },
    // ------- Email -------
    {
      id: "email",
      title: t("navigation.superAdmin.email") || "Email",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="2" y="4" width="20" height="16" rx="3" fill="#FEF3C7" stroke="#F59E0B" strokeWidth="2"/>
          <path d="M2 6L12 13L22 6" fill="#FBBF24" stroke="#D97706" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="18" cy="16" r="2" fill="#EF4444"/>
          <circle cx="18" cy="16" r="1" fill="white"/>
          <path d="M17.5 15.5L18.5 16.5" stroke="white" strokeWidth="1" strokeLinecap="round"/>
        </svg>
      ),
      navLink: "/super-admin/email/analytics",
    },
    // ------- Pulse Reports -------
    {
      id: "pulseReports",
      title: t("navigation.superAdmin.pulseReports") || "Pulse Reports",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="3" y="3" width="18" height="18" rx="3" fill="#E0F2FE" stroke="#0EA5E9" strokeWidth="2"/>
          <path d="M7 12L10 9L14 13L17 10" stroke="#0EA5E9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="7" cy="12" r="1.5" fill="#3B82F6"/>
          <circle cx="10" cy="9" r="1.5" fill="#10B981"/>
          <circle cx="14" cy="13" r="1.5" fill="#F59E0B"/>
          <circle cx="17" cy="10" r="1.5" fill="#EF4444"/>
          <rect x="6" y="16" width="3" height="2" rx="0.5" fill="#0EA5E9"/>
          <rect x="10" y="16" width="3" height="2" rx="0.5" fill="#10B981"/>
          <rect x="14" y="16" width="3" height="2" rx="0.5" fill="#F59E0B"/>
        </svg>
      ),
      navLink: "/super-admin/pulse-reports",
    },
    // ------- SEO -------
    {
      id: "seo",
      title: t("navigation.superAdmin.seo") || "SEO",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 48 48"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g fill="none" strokeWidth="4">
            <rect width="40" height="32" x="4" y="8" fill="#2F88FF" stroke="#000" rx="1.633"/>
            <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" d="M16 18.9479C14 15.9999 10.4978 17.9375 10.7489 20.9687C11 23.9999 15 23.9999 15.2498 27.0311C15.4997 30.0623 12 31.9999 10 29.0519"/>
            <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" d="M26 18H22V31H26"/>
            <path stroke="#fff" strokeLinecap="round" strokeLinejoin="round" d="M22 25H26"/>
            <rect width="6" height="13" x="32" y="18" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" rx="3"/>
          </g>
        </svg>
      ),
      navLink: "/super-admin/seo/programmatic-seo/dashboard",
    },
    // ------- Announcements -------
    {
      id: "announcements",
      title: t("navigation.superAdmin.announcements") || "Announcements",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 8C18 8 20 9 20 12C20 15 18 16 18 16"
            stroke="#F59E0B"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M4 15V9C4 8.44772 4.44772 8 5 8H8L14 4V20L8 16H5C4.44772 16 4 15.5523 4 15Z"
            fill="#FEF3C7"
            stroke="#F59E0B"
            strokeWidth="2"
          />
          <circle cx="17" cy="5" r="2" fill="#EF4444"/>
          <path d="M16 5L18 5" stroke="white" strokeWidth="1.5" strokeLinecap="round"/>
          <rect x="8" y="16" width="3" height="4" rx="1" fill="#10B981"/>
        </svg>
      ),
      navLink: "/super-admin/announcements",
    },
    // ------- Promotions -------
    {
      id: "promotions",
      title: t("navigation.superAdmin.promotions") || "Promotions",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="2" y="4" width="20" height="16" rx="3" fill="#F3E8FF" stroke="#8B5CF6" strokeWidth="2"/>
          <path d="M8 8L16 16M16 8L8 16" stroke="#8B5CF6" strokeWidth="2" strokeLinecap="round"/>
          <circle cx="6" cy="12" r="2" fill="#F59E0B"/>
          <circle cx="18" cy="12" r="2" fill="#10B981"/>
          <rect x="10" y="2" width="4" height="4" rx="1" fill="#EF4444"/>
          <path d="M12 2V0" stroke="#EF4444" strokeWidth="2" strokeLinecap="round"/>
          <circle cx="12" cy="12" r="3" fill="#8B5CF6"/>
          <path d="M11 12L12 13L13 11" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      navLink: "/super-admin/promotions/analytics",
    },
    // ------- Credit Rewards -------
    {
      id: "credits",
      title: t("navigation.superAdmin.credits") || "Credit Rewards",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="10" fill="#FEF3C7" stroke="#F59E0B" strokeWidth="2"/>
          <circle cx="12" cy="12" r="6" fill="#FBBF24"/>
          <path d="M12 8V16M9 11L12 8L15 11M9 13L12 16L15 13" stroke="#92400E" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="18" cy="6" r="3" fill="#10B981"/>
          <path d="M17 6L18 7L19.5 5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="6" cy="18" r="2" fill="#8B5CF6"/>
          <path d="M5 18L7 18" stroke="white" strokeWidth="1" strokeLinecap="round"/>
        </svg>
      ),
      navLink: "/super-admin/credits/analytics",
    },
    // ------- Coupons -------
    {
      id: "coupons",
      title: t("navigation.superAdmin.coupons") || "Coupons",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="2" y="5" width="20" height="14" rx="2" fill="#DCFCE7" stroke="#10B981" strokeWidth="2"/>
          <circle cx="2" cy="10" r="2" fill="white" stroke="#10B981" strokeWidth="1"/>
          <circle cx="2" cy="14" r="2" fill="white" stroke="#10B981" strokeWidth="1"/>
          <circle cx="22" cy="10" r="2" fill="white" stroke="#10B981" strokeWidth="1"/>
          <circle cx="22" cy="14" r="2" fill="white" stroke="#10B981" strokeWidth="1"/>
          <path d="M8 9L16 15M8 15L16 9" stroke="#10B981" strokeWidth="2" strokeLinecap="round"/>
          <circle cx="9" cy="9" r="1.5" fill="#F59E0B"/>
          <circle cx="15" cy="15" r="1.5" fill="#EF4444"/>
        </svg>
      ),
      navLink: "/super-admin/coupons",
    },
    // ------- Plans -------
    {
      id: "plans",
      title: t("navigation.superAdmin.plans") || "Plans",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="3" y="5" width="6" height="14" rx="1" fill="#E0F2FE" stroke="#0EA5E9" strokeWidth="2"/>
          <rect x="9" y="3" width="6" height="16" rx="1" fill="#C7D2FE" stroke="#6366F1" strokeWidth="2"/>
          <rect x="15" y="7" width="6" height="12" rx="1" fill="#DDD6FE" stroke="#8B5CF6" strokeWidth="2"/>
          <path d="M6 8V16" stroke="#0EA5E9" strokeWidth="1.5" strokeLinecap="round"/>
          <path d="M12 6V15" stroke="#6366F1" strokeWidth="1.5" strokeLinecap="round"/>
          <path d="M18 10V16" stroke="#8B5CF6" strokeWidth="1.5" strokeLinecap="round"/>
          <circle cx="6" cy="11" r="0.5" fill="#0EA5E9"/>
          <circle cx="12" cy="9" r="0.5" fill="#6366F1"/>
          <circle cx="18" cy="12" r="0.5" fill="#8B5CF6"/>
          <path d="M3 21H21" stroke="#94A3B8" strokeWidth="1.5" strokeLinecap="round"/>
        </svg>
      ),
      navLink: "/super-admin/plans",
    },
    // ------- Feedbacks -------
    {
      id: "feedback",
      title: t("navigation.superAdmin.feedback") || "Feedback",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M21 11.5C21.0034 12.8199 20.6951 14.1219 20.1 15.3C19.3944 16.7118 18.3098 17.8992 16.9674 18.7293C15.6251 19.5594 14.0782 19.9994 12.5 20C11.1801 20.0035 9.87812 19.6951 8.7 19.1L3 21L4.9 15.3C4.30493 14.1219 3.99656 12.8199 4 11.5C4.00061 9.92179 4.44061 8.37488 5.27072 7.03258C6.10083 5.69028 7.28825 4.60542 8.7 3.90003C9.87812 3.30496 11.1801 2.99659 12.5 3.00003H13C15.0843 3.11502 17.053 3.99479 18.5291 5.47089C20.0052 6.94699 20.885 8.91568 21 11V11.5Z"
            fill="#FEF3C7"
            stroke="#F59E0B"
            strokeWidth="2"
          />
          <circle cx="9" cy="11" r="1" fill="#F59E0B"/>
          <circle cx="12" cy="11" r="1" fill="#F59E0B"/>
          <circle cx="15" cy="11" r="1" fill="#F59E0B"/>
          <circle cx="18" cy="5" r="2" fill="#EF4444"/>
          <path d="M17.2 4.8L18.8 5.2M17.2 5.2L18.8 4.8" stroke="white" strokeWidth="1" strokeLinecap="round"/>
        </svg>
      ),
      navLink: "/super-admin/feedbacks",
    },
    // ------- Leads -------
    {
      id: "leads",
      title: t("navigation.superAdmin.leads") || "Leads",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M2 12L6 8L10 12L14 6L18 10L22 4" stroke="#10B981" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
          <circle cx="6" cy="8" r="2" fill="#3B82F6"/>
          <circle cx="10" cy="12" r="2" fill="#F59E0B"/>
          <circle cx="14" cy="6" r="2" fill="#EF4444"/>
          <circle cx="18" cy="10" r="2" fill="#8B5CF6"/>
          <circle cx="22" cy="4" r="2" fill="#10B981"/>
          <rect x="2" y="16" width="20" height="6" rx="2" fill="#F0F9FF" stroke="#0EA5E9" strokeWidth="1"/>
          <rect x="4" y="17" width="3" height="2" rx="0.5" fill="#0EA5E9"/>
          <rect x="8" y="18" width="3" height="3" rx="0.5" fill="#3B82F6"/>
          <rect x="12" y="17.5" width="3" height="3.5" rx="0.5" fill="#10B981"/>
          <rect x="16" y="18.5" width="3" height="2.5" rx="0.5" fill="#F59E0B"/>
        </svg>
      ),
      navLink: "/super-admin/leads",
    },
    // ------- Prompts -------
    {
      id: "prompts",
      title: t("navigation.superAdmin.prompts") || "Prompts",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect x="3" y="3" width="18" height="18" rx="3" fill="#F3E8FF" stroke="#A855F7" strokeWidth="2"/>
          <path d="M7 8H17" stroke="#A855F7" strokeWidth="2" strokeLinecap="round"/>
          <path d="M7 12H14" stroke="#8B5CF6" strokeWidth="2" strokeLinecap="round"/>
          <path d="M7 16H11" stroke="#7C3AED" strokeWidth="2" strokeLinecap="round"/>
          <circle cx="17" cy="17" r="3" fill="#A855F7"/>
          <path d="M16 17L17 18L18.5 16" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          <circle cx="4" cy="8" r="1" fill="#F59E0B"/>
          <circle cx="4" cy="12" r="1" fill="#10B981"/>
          <circle cx="4" cy="16" r="1" fill="#3B82F6"/>
        </svg>
      ),
      navLink: "/super-admin/prompts",
    },
    // ------- Settings -------
    {
      id: "settings",
      title: t("navigation.superAdmin.settings") || "Settings",
      icon: (
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z" fill="#8B5CF6"/>
          <path d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15Z" stroke="#8B5CF6" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      ),
      navLink: "/super-admin/settings/ai-config",
    },
  ];
  return { superAdminNavArray };
};

export default SuperAdmin;
